import { Stack } from "@mui/material";

const FormActions = props => (
  <Stack direction="row" spacing={2} alignItems="center" {...props} />
);

export default FormActions;
